// Derives the human-readable identifier shown for a project everywhere in the UI.
// Contract from the backend: every project response carries
//   project.service = { Id, Service }  (or null when serviceId IS NULL)
// The identifier is `${service.Service}-${id}`, falling back to just the id
// when the project has no service.
export const getProjectDisplayKey = (project) => {
  if (!project?.id) return '';
  const serviceName = project.service?.Service;
  return serviceName ? `${serviceName}-${project.id}` : String(project.id);
};
